export default {
    formatPercent: function(value, decimals = 0) {
        let locale = 'en-US'
        let options = { style: 'percent', maximumFractionDigits: decimals }

        return new Intl.NumberFormat(locale, options).format(value / 10000000) // permiyad
    }
}